import { useAsyncValue } from 'react-router-dom';

import { isDefined, isOfType } from '@hsp/utilities';

import { IAudience } from 'types/api/audience';
import { BuildAsyncValue, BuildLoader } from 'types/pages/audience-builder/actions';

export const useBuildAsyncValue = (): BuildAsyncValue => {
  const asyncValue = useAsyncValue();

  if (isDefined(asyncValue)) {
    const { dataContainer } = (asyncValue as BuildLoader) ?? { dataContainer: null };

    if (isDefined(dataContainer)) {
      if (isOfType<IAudience>(dataContainer, 'category')) {
        return { data: dataContainer, type: 'audience' };
      }

      return { data: dataContainer, type: 'shop' };
    }
  }
};
